import React from 'react';
import { ReactSVG } from 'react-svg';
import closeIcon from 'assets/images/training/close-icon.svg';

import { Establishment } from 'services/auth/getEstablishments';
import {
  Modal,
  Container,
  BtnContainer,
  Close,
  Button,
  Title,
} from './style';

interface Props {
  isOpen: boolean;
  onRequestClose(): void;
  establishments: Establishment[];
  selectEstablishmentHandler(establishment: Establishment): void;
  loading?: boolean;
}

const EstablishmentModal: React.FC<Props> = ({
  establishments,
  isOpen,
  onRequestClose,
  selectEstablishmentHandler,
  loading,
}) => {
  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose}>
      <Close>
        <button type="button" onClick={onRequestClose}>
          <ReactSVG src={closeIcon} />
        </button>
      </Close>
      <Container>
        <Title>Selecione o canal</Title>
        <BtnContainer>
          {loading ? (
            <Button type="button" buttonRole="tertiary" disabled>
              Carregando...
            </Button>
          ) : (
            establishments.map(est => (
              <Button
                key={est.id}
                type="button"
                buttonRole="tertiary"
                onClick={() => selectEstablishmentHandler(est)}
              >
                {est.client_group}
              </Button>
            ))
          )}
        </BtnContainer>
      </Container>
    </Modal>
  );
};

export default EstablishmentModal;